<template>
  <tr>
    <td>{{ producto.producto_nombre }}</td>
    <td>{{ producto.stock_total }}</td>
  </tr>
</template>

<script>
export default {
  name: 'ProductoListaItem',
  components: {
  },
  props: ['producto'],
  data: function () {
    return {
    }
  }
}
</script>

<style>

</style>
